import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '@material-ui/core';
import React from 'react';
import { StyledText } from '../components/StyledText';
import { useUser } from '../contexts/UserContext';
import { ErrorCode, Role } from '../types/types';

const ErrorView = () => {
  const { logout } = useAuth0();
  const { createUserErrorCode: errorCode } = useUser();
  if (errorCode === ErrorCode.UserAlreadyExistsEmail) {
    const message = 'You\'ve used a different form of authentication to log in to your account than you usually do.';
    const buttonTitle = 'Please log in with your usual form of authentication to continue.';
    return (
      <div style={{ height: '100%', width: '100%', padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <StyledText component='div' style={{ display: 'inline-flex', flexWrap: 'wrap' }}>
          <p>{message}</p>
          <br />
        </StyledText>
        <StyledText component='div' style={{ display: 'inline-flex', flexWrap: 'wrap' }}>
          <Button style={{ display: 'inline-flex', textTransform: 'none' }} variant='text' color='primary' type='button' onClick={() => { logout(); }}>{buttonTitle}</Button>
        </StyledText>
      </div>
    );
  }

  const message = 'Something went wrong. Please,';
  const buttonTitle = 'try again.';
  return (
    <div style={{ height: '100%', width: '100%', padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <StyledText component='div' style={{ display: 'inline-flex', flexWrap: 'wrap' }}>
        <p>{message}</p>
        <Button style={{ display: 'inline-flex', textTransform: 'lowercase' }} variant='text' color='primary' type='button' onClick={() => { logout(); }}>{buttonTitle}</Button>
      </StyledText>
    </div>
  );
};

export default ErrorView;
